import React from 'react';
import PropTypes from 'prop-types';
import Dialog from 'material-ui/Dialog';
import translate from 'components/hoc/translate';
import styled from 'styled-components';
import Loader from 'components/loading/Loader';
import { connect } from 'react-redux';
import { compose } from 'redux';
import RaisedButton from 'material-ui/RaisedButton';
import ReservationSessionForm from './ReservationSessionForm';
import utils from 'helpers/utils';

const StyledLoaderWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

const StyledContentWrapper = styled.div`
    min-height: 72px;
`;

const ReservationSessionStartModal = (props) => {
    const {
        accessPoints,
        accessPointsAccessMethods,
        currentSession,
        isLoading,
        message,
        onCloseModal,
        onHandleSubmit,
        onSelectAccessPoint,
        openGate,
        phase,
        toggleOpenGate,
        translate,
        failures,
    } = props;

    const showLoader = phase === 'loading' || isLoading;
    const closeAction = <RaisedButton label={ translate(`actions.close`) } onTouchTap={ onCloseModal } key='close' />;

    return (
        <Dialog
            actions={ !!message && closeAction }
            modal={ false }
            onRequestClose={ onCloseModal }
            open={ true }
            title={ translate(`resources.reservations.session.modal.title.${ currentSession }`) }
        >
            <StyledContentWrapper>
                {showLoader &&
                    <StyledLoaderWrapper>
                        <Loader />
                    </StyledLoaderWrapper>
                }

                {
                    phase === 'options' &&
                    <ReservationSessionForm
                        onSelectAccessPoint={ onSelectAccessPoint }
                        accessPoints={ accessPoints }
                        accessPointsAccessMethods={ accessPointsAccessMethods }
                        buttonLabel={ translate(`resources.reservations.session.modal.button.submit.${ currentSession }`) }
                        description={ translate(`resources.reservations.session.modal.description.${ currentSession }`) }
                        form='reservationSessionForm'
                        initialValues={ { access_points_access_method_id: null, execute_access: true } }
                        onHandleSubmit={ onHandleSubmit }
                        onCloseModal={ onCloseModal }
                        currentSession={ currentSession }
                        openGate={ openGate }
                        toggleOpenGate={ toggleOpenGate }
                    />
                }

                {phase === 'result' && message !== 'asset-not-usable' &&
                    <div>{message}</div>
                }

                {phase === 'result' && message === 'asset-not-usable' &&
                    <div>
                        <p>{ translate('resources.reservations.session.asset_not_usable.title') }</p>
                        {Array.isArray(failures) &&
                            <ul>
                                {failures.map((failure) => {
                                    return (<li key={ utils.uuid() }>{failure}</li>);
                                })}
                            </ul>
                        }
                        <p>{ translate('resources.reservations.session.asset_not_usable.description') }</p>
                    </div>
                }

            </StyledContentWrapper>
        </Dialog>
    );
};

const mapStateToProps = (state) => {
    return {
        accessPoints: state['access-points'].data,
        accessPointsAccessMethods: state['access-points-access-methods'].data,
        isLoading: state['access-points-access-methods'].loading,
    };
};

const enhance = compose(
    translate,
    connect(
        mapStateToProps,
        null,
    ),
);

ReservationSessionStartModal.propTypes = {
    accessPoints: PropTypes.object,
    accessPointsAccessMethods: PropTypes.object,
    currentSession: PropTypes.string.isRequired,
    failures: PropTypes.array,
    isLoading: PropTypes.bool,
    message: PropTypes.string,
    onCloseModal: PropTypes.func.isRequired,
    onHandleSubmit: PropTypes.func.isRequired,
    onSelectAccessPoint: PropTypes.func.isRequired,
    openGate: PropTypes.bool.isRequired,
    phase: PropTypes.string.isRequired,
    toggleOpenGate: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

export default enhance(ReservationSessionStartModal);



// WEBPACK FOOTER //
// ./src/pages/reservations/show/session/ReservationSessionStartModal.js